import React from 'react'
import { Link } from 'react-router-dom'
import { InternalLink } from '../../../../Routing'
import * as Icons from '../../../../Components/Icons'
import { LinkStyle, SocialIc } from './styles'
import { colors } from '../../../../Components/consts'

type LinksProps = {
  className?: string
  color?: string
  onNavClick?: (target: string) => void
  navs: {
    label: string
    active: boolean
    to: string
    disabled?: boolean
  }[]
  socials?: {
    twitter?: string
    instagram?: string
  }
}

export const Links: React.FC<React.PropsWithChildren<LinksProps>> = ({
  className,
  onNavClick,
  color = colors.blue,
  navs = [],
  socials = {},
}) => {
  return (
    <div className={className}>
      {navs.map((nav, index) => {
        if (nav.disabled === true) {
          return (
            <LinkStyle color={color} key={index} disabled={nav.disabled}>
              {nav.label}
            </LinkStyle>
          )
        }
        if (onNavClick) {
          return (
            <LinkStyle key={index} color={color} active={nav.active}>
              <Link
                to={nav.to}
                onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
                  if (onNavClick) {
                    event.preventDefault()
                    onNavClick(nav.to)
                  }
                }}
              >
                {nav.label}
              </Link>
            </LinkStyle>
          )
        }
        return (
          <LinkStyle  key={index} color={color} active={nav.active}>
            <InternalLink name="player" params={nav.to}>
              {nav.label}{' '}
            </InternalLink>
          </LinkStyle>
        )
      })}
      {socials.twitter && (
        <SocialIc href={socials.twitter} aria-label="Twitter">
          <Icons.Twitter />
        </SocialIc>
      )}
      {socials.instagram && (
        <SocialIc href={socials.instagram} aria-label="Instagram">
          <Icons.Instagram />
        </SocialIc>
      )}
    </div>
  )
}
